/**
 * Model representing a log entry for master post operations
 */
export class LogMasterPosto {
  constructor(
    public readonly id: number,
    public readonly master: string,
    public readonly usuario: string,
    public readonly usuarioAfetado: string,
    public readonly tipoAcao: TipoAcao,
    public readonly acao: string,
    public readonly dataHora: Date,
    public readonly detalhes: string
  ) {}

  static fromJson(json: any): LogMasterPosto {
    return new LogMasterPosto(
      json.id,
      json.master || '',
      json.usuario || '',
      json.usuarioAfetado || '',
      json.tipoAcao as TipoAcao,
      json.acao || '',
      json.dataHora ? new Date(json.dataHora) : new Date(),
      json.detalhes || ''
    );
  }

  getIcon(): string {
    switch (this.tipoAcao) {
      case TipoAcao.CRIACAO:
        return 'add_circle';
      case TipoAcao.EDICAO:
        return 'edit';
      case TipoAcao.EXCLUSAO:
        return 'delete';
      default:
        return 'help_outline';
    }
  }

  getRowClass(): string {
    switch (this.tipoAcao) {
      case TipoAcao.CRIACAO:
        return 'acao-criacao';
      case TipoAcao.EDICAO:
        return 'acao-edicao';
      case TipoAcao.EXCLUSAO:
        return 'acao-exclusao';
      default:
        return '';
    }
  }
}

/**
 * Action types enum
 */
export enum TipoAcao {
  CRIACAO = 1,
  EDICAO = 2,
  EXCLUSAO = 3,
}
